import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { PagedResult, RequestListItem } from "@gw/shared-types";
import { listRequests, type ListRequestsParams } from "@/api/endpoints";
import { parseRequestListPage } from "@/api/parsers";

export function useRequestListQuery(params: ListRequestsParams) {
  return useQuery<PagedResult<RequestListItem>>({
    queryKey: ["requests", params],
    queryFn: async () => parseRequestListPage(await listRequests(params)),
    staleTime: 60_000,
    // Keep showing the previous page of results while the new query is in flight. Without this,
    // every keystroke in the search box (or filter chip toggle) blanks the table until the
    // refetch lands — visible as a flicker.
    placeholderData: keepPreviousData,
  });
}
